import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Button, FormControlLabel, Grid, Switch, TextField, Typography } from '@material-ui/core';
import feathersServices from '../../../services/feathersServices';

function CapabilitiesManagementForm(props) {
  const { onClose, onSave, selectedElement, category, classes, industry } = props;

  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState('');
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (selectedElement) {
      setTitle(selectedElement.title);
      setDescription(selectedElement.description);
      setActive(selectedElement.active);
    }
  }, [selectedElement]);

  const handleSave = async () => {
    if (selectedElement?._id) {
      await props.saveCapability(selectedElement._id, {
        title,
        description,
        active
      });
    } else {
      await props.createCapability({
        title,
        description,
        active,
        category: category._id
      });
    }
    onSave();
    onClose();
  };

  return (
    <>
      <Box className={classes.header} display="flex" alignItems="center" p={2} mb={2}>
        <Typography variant="h5" color="primary">
          {selectedElement?.title || 'Add new capability'}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" justifyContent="space-between" p={2} height={1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField required disabled={true} defaultValue={industry.title} color="secondary" label="Industry" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <TextField required disabled={true} defaultValue={category.title} color="secondary" label="Category" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              value={title || ''}
              color="secondary"
              label="Title"
              fullWidth
              error={title === ''}
              variant="outlined"
              onChange={({ target }) => setTitle(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={description}
              multiline
              minRows={4}
              maxRows={4}
              color="secondary"
              label="Description"
              fullWidth
              variant="outlined"
              onChange={({ target }) => setDescription(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              p={1}
              border="1px solid"
              borderColor="grey.400"
              alignItems="center"
              borderRadius="borderRadius"
              className={classes.fieldset}
            >
              <FormControlLabel
                control={<Switch checked={active} onChange={({ target }) => setActive(target.checked)} />}
                labelPlacement="start"
                label="Status"
              />
              &nbsp;&nbsp;
              <Typography component="span">{active ? 'Active' : 'Disabled'}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          &nbsp;
          <Button disabled={!title} onClick={handleSave} color="secondary" variant="contained" disableElevation style={{ height: 40 }}>
            {selectedElement ? 'Update' : 'Create'}
          </Button>
        </Grid>
      </Box>
    </>
  );
}

const mapDispatchToProps = {
  saveCapability: feathersServices.capabilities.patch,
  createCapability: feathersServices.capabilities.create
};

export default connect(null, mapDispatchToProps)(CapabilitiesManagementForm);
